import { Col, message, Row } from "antd";
import { useHistory } from "react-router";
import { useEffect, useRef, useState } from "react";

import "./gradeMapTable.less";
import Table from "@components/Table";
import Button from "@components/Button";
import {
  useDownloadGradeTableQuery,
  useFetchAllGradeCompaniesQuery,
  useFetchTARanksQuery,
  useUploadGradeTableMutation,
} from "@services";
import { IGradeCompany } from "@types";
import { checkPermission, getRows } from "@utils";
import { paths, permissions } from "@router";
import customErrorMessage from "@/components/CustomErrorMessage";

const default_cols = [
  {
    title: <div className="text-wrap">ta rank</div>,
    dataIndex: "rank",
    key: "taRank",
    width: 300,
  },
];

const GradeMapTable = () => {
  const history = useHistory();
  const inputRef = useRef<any>(null);
  const tableRef = useRef<any>(null);
  const [download, setDownload] = useState(false);
  const [tableHeight, setTableHeight] = useState(0);
  const [uploadGradeTable, { isLoading: isUploading }] =
    useUploadGradeTableMutation();
  const { isLoading: isDownloading } = useDownloadGradeTableQuery(null, {
    skip: !download,
  });
  const { data: taRanksData, error } = useFetchTARanksQuery(null);
  const { data: taRanks } = taRanksData || {};
  const {
    data: companiesData,
    isLoading: isLoadingCompanies,
    error: companiesError,
  } = useFetchAllGradeCompaniesQuery(null);
  const { data: companies } = companiesData || {};

  const handleTableCell = (e: any) => {
    const id = e.currentTarget.dataset.id;
    const grade_company = companies.find(
      (company: IGradeCompany) => +company?.id === +id
    );
    history.push(paths.admin.settings.grade_map_table.edit_grade_company, {
      grade_company: {
        ...grade_company,
        grade_company_ranks: grade_company?.grade_company_ranks,
      },
    });
  };

  const additional_cols: any =
    (!error &&
      companies?.map((company: IGradeCompany) => ({
        title: (
          <div
            className="grade__header__row__btn text-wrap"
            data-id={company.id}
            onClick={() => {}}
            // onClick={handleTableCell}
          >
            {company.name}
          </div>
        ),
        dataIndex: company.name.replace(/\s/g, ""),
        key: company.id,
        width: 300,
      }))) ||
    [];
  const columns = [...default_cols, ...additional_cols];

  const rows =
    !error && !companiesError && companies?.length && taRanks?.length
      ? getRows(taRanks, companies)
      : [];

  console.log(rows, "main");

  const handleAddBtn = () => {
    history.push(paths.admin.settings.grade_map_table.create_grade_company);
  };

  // const uploadFile = async (event: any) => {
  //   event.stopPropagation();
  //   event.preventDefault();
  //   var file = event?.target?.files[0];
  //   try {
  //     const formData = new FormData();
  //     formData.append("attachment", file, file.name);
  //     await uploadGradeTable(formData).unwrap();
  //     message.success("CSV Data Uploaded Successfully");
  //   } catch (error) {
  //     customErrorMessage(error?.message);
  //     console.log(error);
  //   }
  // };

  // khurram new
  // const uploadFile = async (event: any) => {
  // event.stopPropagation();
  // event.preventDefault();
  // const file = event?.target?.files[0];

  // try {
  //   const formData = new FormData();
  //   formData.append("attachment", file, file.name);
  //   const response = await uploadGradeTable(formData).unwrap();

  //   // ✅ Success message
  //   message.success("CSV Data Uploaded Successfully");

  // } catch (error: any) {
  //   console.log(error,"1");

  //   // Check for error array in response
  //   if (Array.isArray(error.error) && error.error.length > 0) {
  //     error.error.forEach((errMsg: string) => {
  //       customErrorMessage(errMsg);
  //     });
  //   } else {
  //     // Fallback to top-level message or generic error
  //     customErrorMessage(error?.message || error?.message || "Upload failed");
  //   }
  // }
  // };

  // Mudassir Code for Upload
  const uploadFile = async (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    const file = event?.target?.files[0];

    // Reset the input value
    if (inputRef.current) {
      inputRef.current.value = "";
    }

    // Check if a file was selected
    if (!file) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("attachment", file, file.name);
      const response = await uploadGradeTable(formData).unwrap();

      message.success("CSV Data Uploaded Successfully");
    } catch (err: any) {
      console.log(err, "1");
      if (Array.isArray(err.error) && err.error.length > 0) {
        err.error.forEach((errMsg: string) => {
          customErrorMessage(errMsg);
        });
      } else {
        customErrorMessage(err?.message || err?.message || "Upload failed");
      }
    }
  };

  useEffect(() => {
    const TabTop = tableRef.current.getBoundingClientRect();
    setTableHeight(window.innerHeight - TabTop.top - 100);
  }, []);

  return (
    <>
      <div className="appTitle text-base font-[500] mx-5">
        Companies Grade Map Table
      </div>
      <div className="jobCreationBar  sticky top-0 z-10 bg-white px-14 py-6 rounded-lg flex justify-between items-center my-7">
        <div className="title text-themeBlue font-[500] text-3xl">
          Companies Grade Map Table
        </div>

        {checkPermission(permissions.CREATE_COMPANY_USER) && (
          <div className="action-buttons flex items-center gap-2">
            <input
              id="myInput"
              type="file"
              ref={inputRef}
              hidden={true}
              onChange={uploadFile}
            />
            <Button
              // isLoading={isUploading}
              variant="add"
              icon={false}
              onClick={() =>
                history.push(
                  paths.admin.settings.grade_map_table.edit_grade_company
                )
              }
            >
              Add / Edit
            </Button>
            <Button
              isLoading={isUploading}
              variant="upload"
              onClick={() => inputRef?.current?.click()}
            >
              Upload Grade Map
            </Button>

            <Button
              variant="download"
              onClick={() => setDownload(true)}
              isLoading={isDownloading}
            >
              Download Grade Map
            </Button>
          </div>
        )}
      </div>
      {/* <Row className="mt-16 mb-20">
        <Col className="align-start" span={16}>
          <input
            id="myInput"
            type="file"
            ref={inputRef}
            hidden={true}
            onChange={uploadFile}
          />
          <Button
            isLoading={isUploading}
            variant="upload"
            onClick={() => inputRef?.current?.click()}
          >
            Upload Grade Map
          </Button>
          <Button
            variant="download"
            onClick={() => setDownload(true)}
            isLoading={isDownloading}
          >
            Download Grade Map
          </Button>
        </Col>
        <Col className="align-end" span={8}>
          <Button variant="add" onClick={handleAddBtn}>
            Add new company
          </Button>
        </Col>
      </Row> */}

      <div className="jobCreationListing bg-white px-14 py-6 rounded-lg">
        <div ref={tableRef} style={{ width: "100%", overflowX: "auto" }}>
          <Table
            scroll={400}
            data={rows}
            columns={columns}
            pagination={false}
            isLoading={isLoadingCompanies}
          />
        </div>
      </div>
    </>
  );
};
export default GradeMapTable;
